export const FIELD_WORK = 'field_work';
export const SHIPMENTS = 'shipping_and_receiving';
export const LAB_PROCESSING = 'lab_processing';

export const topLevelCategories = [FIELD_WORK, SHIPMENTS, LAB_PROCESSING];

export const ALL = 'all';
export const UNASSIGNED = 'unassigned';
export const ASSIGNED = 'assigned';
export const IN_PROGRESS = 'in_progress';
export const COMPLETED = 'completed';

export const dispatchStatuses = [ALL, UNASSIGNED, ASSIGNED, IN_PROGRESS, COMPLETED];

export const dispatchStatusDisplayNames: { [key: string]: string } = {
  [ALL]: 'all',
  [FIELD_WORK]: 'fieldWork',
  [SHIPMENTS]: 'shippingReceiving',
  [LAB_PROCESSING]: 'labProcessing',
};

export const CREATED = 'created';
export const SAMPLED = 'sampled';
export const SHIPPED = 'shipped';
export const ARRIVED = 'arrived';
export const PROCESSING = 'processing';

export const sampleMetricDisplayNames: { [key: string]: string } = {
  [CREATED]: 'open',
  [SAMPLED]: 'sampled',
  [SHIPPED]: 'shipped',
  [ARRIVED]: 'arrived',
  [PROCESSING]: 'completed',
};
